
export async function postToServer(url, data) {
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    };
    await fetch(url, options);
}

export async function getFromServer(url) {
    var res;

    await fetch(url)
        .then((response) => {
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1)
                return response.json();
            else 
                return response.text();
        })
        .then((data) => {
            res = data;
        });

    return res;
};
